import type { FilteknProduct } from '../types/snak'

export const products: FilteknProduct[] = [
  {
    id: 'supreme',
    headline: 'Meet Filtek Supreme.',
    name: 'Filtek Supreme',
    traits: ['Precise', 'Detail-focused', 'Built for aesthetic control'],
    question: 'What does that sound like?',
    answer: 'firstborn',
    answerLabel: 'Firstborn',
    supporting: 'The one who likes things done properly.',
    closing: 'For cases where aesthetic control really matters.',
    accent: '#0F62AB',
  },
  {
    id: 'easyMatch',
    headline: 'Meet Filtek Easy Match.',
    name: 'Filtek Easy Match',
    traits: ['Simple', 'Adaptable', 'Easy to get along with'],
    question: 'What does that sound like?',
    answer: 'middle',
    answerLabel: 'Middle child',
    supporting: 'Good at adapting without making things complicated.',
    closing:
      'Designed around everyday simplicity and intuitive shade matching.',
    accent: '#6E4A9E',
  },
  {
    id: 'oneBulkFill',
    headline: 'Meet Filtek One Bulk Fill.',
    name: 'Filtek One Bulk Fill',
    traits: ['Fast', 'Practical', 'Gets things done'],
    question: 'Which sibling does that sound like?',
    answer: 'youngest',
    answerLabel: 'Youngest',
    supporting:
      'Less interested in tradition. More interested in getting there efficiently.',
    closing: 'Designed for posterior efficiency and simplicity.',
    accent: '#05dd4d',
  },
]
